import router from '../../shared/router';
import MenuService from '../../core/components/sidebar/MenuService';
import MenuItem from '../../core/components/sidebar/MenuItem';
import LoanCalculator from './LoanCalculator';

const {routes} = router.options;
const route = routes.find(r => r.path === '/app');

const tmpRoutes = [
  {
    path: 'loan-calculator',
    name: 'loanCalculator',
    component: LoanCalculator,
    meta: {
      requiresAuth: true,
    },
  },
];

tmpRoutes.forEach((obj) => {
  route.children.push(obj);
});

router.addRoutes([route]);
// MenuService.addItem(new MenuItem('loan-calculator', {
//   path: '/app/loan-calculator',
//   text: 'Loan Calculator',
//   uuid: 'Loan Calculator',
//   permission: 'write',
//   weight: 0,
//   icon: ['fas', 'calculator']
// }));
